<template>
    <div class="swiper-column swiper-main-container">
        <div v-show="images.length" :style="`height: ${swiper_height}px`">
            <swiper class="swiper gallery-top" :options="swiperOptionTop" ref="swiperTop">
                <swiper-slide v-for="image in images" :key="image" :style="`background-image: url('${image}')`">
                    <i class="mdi mdi-close delete-button" title="Remove Image" v-if="canRemove"
                       @click="removeImage(image)"></i>
                    <button type="button" class="btn btn-primary btn-sm front-button" v-if="canSetFrontImage"
                            :disabled="isDefaultImage(image)"
                            @click="setDefault(image)">
                        <template v-if="isDefaultImage(image)">
                            <i class="mdi mdi-check"></i> Default
                        </template>
                        <template v-else>Set as Default</template>
                    </button>
                    <div class="clearfix"></div>
                </swiper-slide>
                <div class="swiper-button-next swiper-button-white" slot="button-next"></div>
                <div class="swiper-button-prev swiper-button-white" slot="button-prev"></div>
            </swiper>
            <swiper class="swiper gallery-thumbs" :options="swiperOptionThumbs" ref="swiperThumbs" v-show="hasThumbs">
                <swiper-slide v-for="image in images" :style="{'background-image': `url(${image})`}"
                              :key="image"></swiper-slide>
            </swiper>
        </div>
        <div v-show="!images.length" :style="`height: ${swiper_height}px;`">
            <img :style="`height: ${swiper_height - 13}px; object-fit: cover`" alt="" src="/images/no-image.png"
                 width="100%">
        </div>
        <slot/>
    </div>
</template>

<script>
import {Swiper, SwiperSlide} from 'vue-awesome-swiper'

export default {
    props: {
        hasThumbs: {
            type: Boolean,
            default: true
        },
        canRemove: {
            type: Boolean,
            default: false
        },
        canSetFrontImage: {
            type: Boolean,
            default: false
        },
        defaultImage: {
                type: String,
            },
            images: {
                type: Array,
                default() {
                    return [];
                }
            }
        },
        components: {
            Swiper,
            SwiperSlide
        },
        data() {
            return {
                galleryThumbs: null,
                galleryTop: null,
                swiper_height: 434,
                swiper_images: [],
                swiperOptionTop: {
                    loop: true,
                    loopedSlides: 5, // looped slides should be the same
                    spaceBetween: 10,
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev'
                    }
                },
                swiperOptionThumbs: {
                    loop: true,
                    loopedSlides: 5, // looped slides should be the same
                    spaceBetween: 10,
                    centeredSlides: true,
                    slidesPerView: 'auto',
                    touchRatio: 0.2,
                    slideToClickedSlide: true
                }
            }
        },
        mounted() {
            this.$nextTick(() => {
                if (this.$refs.swiperTop && this.$refs.swiperThumbs) {
                    const swiperTop = this.$refs.swiperTop.$swiper;
                    const swiperThumbs = this.$refs.swiperThumbs.$swiper;
                    swiperTop.controller.control = swiperThumbs;
                    swiperThumbs.controller.control = swiperTop;
                }
                this.setSwiperHeight();
            });
            this.$nextTick(() => {
                window.addEventListener('resize', () => {
                    this.setSwiperHeight();
                });
            });
            window.Bus.$on('onClickButtonMenu', () => {
                this.setSwiperHeight();
            });
        },
        methods: {
            isDefaultImage(image) {
                return this.defaultImage === image
            },
            setSwiperHeight() {
                this.swiper_height = (434 / 579) * this.$el.clientWidth;
                this.$nextTick(() => {
                    if (this.images.length > 1) {
                        this.swiper_height = (this.swiper_height + (this.swiper_height * .2)) + 13;
                    }
                });
            },
            removeImage(image) {
                this.$confirm('Are you sure you want to remove this image?', 'Confirm', {
                    confirmButtonText: 'OK',
                    cancelButtonText: 'Cancel',
                    type: 'warning'
                })
                    .then(() => {
                        let index = this.images.indexOf(image);
                        this.$emit('removeItem', image, index);
                    })
                    .catch(() => {
                    })
            },
            setDefault(image) {
                this.$confirm('Are you sure to set this as the default image?', 'Confirm', {
                    confirmButtonText: 'OK',
                    cancelButtonText: 'Cancel',
                    type: 'warning'
                }).then(() => {
                    let index = this.images.indexOf(image);
                    this.$emit('frontItem', image, index);
                })
                    .catch(() => {
                    })
            },
        },
    }
</script>
